import React from 'react';
import BaseBanner from '../core/BaseBanner';
import BannerWithDismissal from '../core/BannerWithDismissal';
import { DismissibleBannerProps } from '../types';
import { useThemeContext } from 'contexts/theme';
import { isThemeExpUS } from '@tenants/utils/which-tenant';

interface FloatingBannerProps extends DismissibleBannerProps {
  onButtonClick?: () => void;
}

const FloatingBanner: React.FC<FloatingBannerProps> = props => {
  const { theme: appTheme } = useThemeContext();
  
  const floatingBannerSx = {
    position: 'fixed',
    bottom: 20,
    left: '50%',
    transform: 'translateX(-50%)',
    boxShadow: isThemeExpUS ? appTheme.decorations.boxShadow : '0px 4px 12px rgba(0, 0, 0, 0.1)',
    zIndex: 1400,
    width: '90vw',
    
    '@media (min-width: 768px)': {
      width: 'auto',
      minWidth: '50vw',
      maxWidth: '800px',
    },
  };
  
  return (
    <BannerWithDismissal {...props}>
      {({ isDismissed, onDismiss, actionButton }) => {
        if (isDismissed) return null;
        
        const isDismissible = !props.persistent;
        
        return (
          <BaseBanner
            {...props}
            onDismiss={onDismiss}
            showCloseButton={isDismissible}
            actionButton={actionButton}
            sx={floatingBannerSx}
          />
        );
      }}
    </BannerWithDismissal>
  );
};

export default FloatingBanner; 